import { dissoc, mergeDeepRight, uniq } from 'ramda';
import { createSlice } from '@reduxjs/toolkit';
import { CONVERSATIONS, LOGOUT_USER } from '../namespace';

export const initialState = (activeIds = []) => ({
  byId: {},
  allIds: [],
  activeIds,
});

const addConversation = (state, conversation) => {
  state.byId = mergeDeepRight(state.byId, {
    [conversation.id]: dissoc('lastMessage', conversation),
  });
  state.allIds = uniq([...state.allIds, conversation.id]);
};

const withConversation = (conversation) => ({ payload: { conversation } });

const conversationsSlice = createSlice({
  name: CONVERSATIONS,
  initialState: initialState(),
  reducers: {
    update: {
      reducer: (state, { payload }) => {
        addConversation(state, payload.conversation);
      },
      prepare: withConversation,
    },
    register_active: {
      reducer: (state, { payload }) => {
        addConversation(state, payload.conversation);
        state.activeIds = uniq([...state.activeIds, payload.conversation.id]);
      },
      prepare: withConversation,
    },
  },
  extraReducers: (builder) => {
    builder.addCase(LOGOUT_USER, (state) => {
      state.byId = {};
      state.allIds = [];
    });
  },
});

export const {
  update: updateConversation,
  register_active: registerActive,
} = conversationsSlice.actions;

export default { [CONVERSATIONS]: conversationsSlice.reducer };
